import SsciStudentEventPointPage from "./SsciStudentEventPointPage";

export default SsciStudentEventPointPage